import { render, staticRenderFns } from "./ImportContainer.vue?vue&type=template&id=19ccdeb5&scoped=true"
import script from "./ImportContainer.vue?vue&type=script&lang=js"
export * from "./ImportContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ccdeb5",
  null
  
)

export default component.exports